import React, { useRef } from 'react';
import {
  Layout,
  Layouts,
  Responsive,
  ResponsiveProps,
} from 'react-grid-layout';

// -- type definitions --
type Breakpoint = 'lg' | 'md' | 'sm' | 'xs' | 'xxs';

export interface EnhancedResponsiveGridLayoutProps
  extends Omit<ResponsiveProps, 'onLayoutChange'> {
  onLayoutChange?: (
    currentLayout: Layout[],
    allLayouts: Layouts,
    currentBreakpoint: Breakpoint
  ) => void;
}

// -- main component --

/**
 * Container over the Responsive component from react-grid-layout that manages the current breakpoint internally
 */
export const EnhancedResponsiveGridLayout: React.FC<
  EnhancedResponsiveGridLayoutProps
> = ({ onLayoutChange, onBreakpointChange, ...restProps }) => {
  const currentBreakpointRef = useRef<Breakpoint>('lg');

  const handleBreakpointChange = (
    newBreakpoint: string,
    newCols: number
  ): void => {
    currentBreakpointRef.current = newBreakpoint as Breakpoint;
    if (onBreakpointChange) {
      onBreakpointChange(newBreakpoint, newCols);
    }
  };

  const handleLayoutChange = (
    currentLayout: Layout[],
    allLayouts: Layouts
  ): void => {
    if (onLayoutChange) {
      onLayoutChange(currentLayout, allLayouts, currentBreakpointRef.current);
    }
  };

  return (
    <Responsive
      {...restProps}
      onBreakpointChange={handleBreakpointChange}
      onLayoutChange={handleLayoutChange}
    />
  );
};
